import type { Contact, Member } from "./types";

export const ENVIRONMENT = import.meta.env.VITE_ENV || '';
export const PANADATA_ROOT = import.meta.env.VITE_PANADATA_ROOT || '';

export const customDocusealCss = `
  #submit_form_button, 
  #expand_form_button,
  .base-button,
  .btn.btn-outline:hover {
    background-color: #212529;
    border: 1px solid #212529;
    border-radius: 0.375rem;
    color: #fff;
  }
  #submit_form_button:disabled,
  .btn.btn-outline {
    background-color: transparent;
    border: 1px solid #212529;
    border-radius: 0.375rem;
    color: #212529;
  }
`;

export const getCsrfToken = () => document.querySelector("[name='csrf-token']")?.getAttribute('content') || "";

export const getLanguage = () => {
  const path = window.location.pathname;
  const locale = path.includes('/en/') ? 'en' : 'es';
  return locale;
};

// Función genérica para realizar solicitudes a la API
export const apiRequest = async (url: string, method = 'GET', body: any = null, isFormData = false) => {
  const csrfToken = getCsrfToken();
  const headers = {
    'X-CSRF-Token': csrfToken,
    'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
  };

  const config: RequestInit = {
    method,
    headers,
    mode: 'cors',
    cache: 'no-cache',
    credentials: ENVIRONMENT === 'development' ? 'include' : 'same-origin'
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${PANADATA_ROOT}${url}`, config);
    if (!response.ok) {
      throw new Error(`Error en la solicitud, estado ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error en la solicitud API:", error);
    throw error;
  }
};

// Función para enviar eventos a Mixpanel
export const sendEvent = async (payload: any) => {
  const csrfToken = getCsrfToken();

  await fetch(`${PANADATA_ROOT}/send_event`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: ENVIRONMENT === 'development' ? 'include' : 'same-origin',
    headers: {
      "X-CSRF-Token": csrfToken.toString(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({payload: payload})
  });
}

export const getLocale = (): string => {
  const url = window.location.pathname;
  const locale = url.split('/')[1];
  return locale || 'es';
};

/**
 * Helper: Check if contacts step (Step 1) is complete
 * All members must have corresponding contacts with email + telefono
 */
export const isContactsStepComplete = (contacts: Contact[], members: Member[]): boolean => {
  if (contacts.length === 0 || members.length === 0) return false;
  
  // All members should have corresponding contacts with email + telefono
  return members.every(member => 
    contacts.some(contact => 
      contact.nombre === member.nombre && 
      contact.cargo === member.cargo &&
      !!(contact.email && contact.telefono)
    )
  );
};

/**
 * Helper: Check if beneficiaries step (Step 2) is complete
 * Sum of porcentaje_beneficio should equal 100%
 */
export const isBeneficiariesStepComplete = (contacts: Contact[]): boolean => {
  // const beneficiaries = contacts.filter(c => c.beneficiario);
  // if (beneficiaries.length === 0) return false;
  
  const sum = contacts.reduce((acc, c) => 
    acc + parseFloat(c.porcentaje_beneficio), 0
  );
  
  // Allow small floating point variance (99-100)
  return sum >= 99 && sum <= 100;
};